import { useTranslation } from 'react-i18next';
import { generateClassName } from '@klaviyo-mkt/gatsby-components/shared/utils/functions';
import AccountAccessForm from '@klaviyo-mkt/gatsby-components/organisms/form-account-access';
import { Anchor } from '@klaviyo-mkt/gatsby-components/atoms/anchor';
import ArticleMeta from '@klaviyo-mkt/gatsby-components/molecules/article-meta';
import GlobalHead from '../../components/head';
import Layout from '../../layout';

import * as s from './styles/accountAccessRequest.module.css';

import type { HeadProps, PageProps } from 'gatsby';
import type { IPageContext } from '../../components/head/types';

export const AccountAccessRequest = ({ location, ...pageProps }: PageProps) => {
  const { t } = useTranslation();

  return (
    <Layout
      {...pageProps}
      headerChildren={(
        <div className={s.supportRequestHeader}>
          <div className={s.breadcrumbs}>
            <Anchor to={t('organisms_forms_accountAccessForm_breadcrumb_href')}>
              {t('organisms_forms_accountAccessForm_breadcrumb_label')}
            </Anchor>
            <div>/</div>
            <div>{t('organisms_forms_accountAccessForm_currentBreadcrumb')}</div>
          </div>
          <ArticleMeta
            title={t('organisms_forms_accountAccessForm_articleMetaTitle')}
            topic='Support'
            topicSourceId='Support'
          />
        </div>
      )}
      location={location}
      showMoreCards={false}
    >
      <div className={generateClassName([s.pageWrapper, 'grid'])}>
        <div className={s.header}>
          <h1 className='h5 medium'>{t('organisms_forms_accountAccessForm_headline')}</h1>
          <div className={generateClassName([s.textPaddingTop, 'p2'])}>
            {t('organisms_forms_accountAccessForm_subhead')}
          </div>
        </div>
        <div className={s.formContainer}>
          <div className={s.form}>
            <AccountAccessForm backgroundColor='light' />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AccountAccessRequest;

export const Head = ({ location, pageContext }: HeadProps<null, IPageContext>) => (
  <GlobalHead
    langCode={pageContext?.locale}
    pathname={location.pathname}
    pageType='account'
  />
);
